import React from 'react';
import './CredentialsForm.css'; // Optional for styling

const CredentialsForm = ({
  formData,
  handleInputChange,
  saveCredentials,
  isLoading,
  message
}) => {
  return (
    <div className="form-container">
      <h2>Enter Your API Credentials</h2>

      <div className="form-group">
        <label>Source:</label>
        <select
          name="source"
          value={formData.source || ''}
          onChange={handleInputChange}
          required
        >
          <option value="" disabled>Select an Option</option>
          <option value="indiamart">IndiaMart</option>
          <option value="tradeindia">Trade India</option>
        </select>
      </div>

      {(formData.source === 'indiamart') && (
        <>
          <div className="form-group">
            <label>Username:</label>
            <input 
              type="text" 
              name="username" 
              value={formData.username || ''}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Password:</label>
            <input 
              type="password" 
              name="password" 
              value={formData.password || ''}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>API Key:</label>
            <input 
              type="text" 
              name="apikey" 
              value={formData.apikey}
              onChange={handleInputChange}
              required
            />
          </div>
        </>
      )}

      {(formData.source === 'tradeindia') && (
        <>
          <div className="form-group">
            <label>Username:</label>
            <input 
              type="text" 
              name="username" 
              value={formData.username || ''}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Password:</label>
            <input 
              type="password" 
              name="password" 
              value={formData.password || ''}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>User ID:</label>
            <input 
              type="text" 
              name="userid" 
              value={formData.userid}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Profile ID:</label>
            <input 
              type="text" 
              name="profileid" 
              value={formData.profileid}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>API Key:</label>
            <input 
              type="text" 
              name="apikey" 
              value={formData.apikey}
              onChange={handleInputChange}
              required
            />
          </div>
        </>
      )}

      <button 
        onClick={saveCredentials} 
        disabled={isLoading}
        className="btn save-btn"
      >
        {isLoading ? 'Saving...' : 'Save Credentials'}
      </button>
      {message && (
        <p className={`message ${message.includes('success') ? 'success' : 'error'}`}>
          {message}
        </p>
      )}
    </div>
  );
};

export default CredentialsForm;
